import { httpDelete, httpGet, httpPost, httpPut } from '../services/http'
import authProvider from '../utils/authProvider'

const acqVisitsApi = process.env.REACT_APP_ACQ_VISITS_API

const postProcessDescription = (data) => {
  const regex = /\(\(.*\)\)/
  const subst = ``
  const str = data.description
  data.description = str.replace(regex, subst) ?? ''
  return data
}

const preProcessDescription = (data) => {
  data.description = data.description
    ? data.description + ' (( ' + window.location.origin + '/#/leadProperties/' + data.lead_property_id + '/visits ))'
    : '(( ' + window.location.origin + '/#/leadProperties/' + data.lead_property_id + '/visits ))'
  return data
}

const VisitProvider = {
  getList: async (resource, { pagination, filter }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${acqVisitsApi}?f=${JSON.stringify(filter)}&p=${JSON.stringify(pagination)}`
    const { data: response } = await httpGet({ url, config: { headers } })
    const items = response.items?.map((data) => postProcessDescription(data))
    return Promise.resolve({ data: items, total: response.count })
  },

  getOne: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${acqVisitsApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: postProcessDescription(response) })
  },

  update: async (resource, { data, id }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPut({
      url: `${acqVisitsApi}/${id}`,
      config: { headers },
      data: preProcessDescription(data),
    })
    response.lead_property_id = data.lead_property_id
    return Promise.resolve({ data: postProcessDescription(response) })
  },

  create: async (resource, params) => {
    const data = { ...params.data }
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpPost({ url: `${acqVisitsApi}`, config: { headers }, data: preProcessDescription(data) })
    response.lead_property_id = data.lead_property_id
    return Promise.resolve({ data: postProcessDescription(response) })
  },

  delete: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpDelete({ url: `${acqVisitsApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: response })
  },
}

export default VisitProvider
